<template>
  <div id="content-inner-container">
    <component-gallery-header></component-gallery-header>
    <div 
      class="tuka-loading-content spinner"
      v-show="tukaReady == false"
    >
    </div>

    <a @click.prevent="focusMainContent()" href="#tuka-main-content" id="tuka-skip-to-main-content">{{$t('tuka.navigation.skip_to_main_content')}}</a>
    
    <section class="row tukave-content">
      <side-navigation-list 
        class="tukave-side-nav mb-4 mb-lg-0 pl-lg-0"
      />
      <main-content 
        class="tukave-main-content"
        :class="mainContentCss()"
      />
    </section>
  </div>
</template>

<script>
import ComponentGalleryHeader from "./ComponentGalleryHeader.vue";
import MapButton from "./MapButton.vue";
import SideNavigationList from "./SideNavigationList.vue";
import MainContent from "./MainContent.vue";
import { mapActions, mapGetters } from "vuex";

import axios from "axios";

import { getLocationDataArray, getContentObjects} from "../store/helpers";

import * as http from "../http";

export default {
  name: "ComponentPage",
  components: {
    ComponentGalleryHeader,
    MapButton,
    SideNavigationList,
    MainContent,
    getLocationDataArray,
    getContentObjects
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["mainContent", "currentItemLocationData", "getSettings", "tukaReady", "initialLoad"]),
  },
  methods: {
    ...mapActions(["setScrollingReserved"]),
    mainContentCss() {
      if (this.getSettings.showContentWindowInFullWidth) {
        return "col-md-12 col-lg-12";
      }
      return "col-md-12 col-lg-8";
    },
    focusMainContent() {
      this.$nextTick(function() {
        // Focus main content area
        document.getElementById('tuka-content-container').focus({
          preventScroll: true
        });
      });
    }
  },
  created() {},
  watch: {
    'mainContent': {
      handler(newValue, oldValue) {

        this.$nextTick(() => {
          // Check if hash item has been requested
          if (this.$router.currentRoute.hash) {

            let hashItem = jQuery(this.$router.currentRoute.hash);

            const scrollToTarget = (target, bhv) => {
              target.scrollIntoView({behavior: bhv});
              target.focus({preventScroll: true});
            }
            
            if (hashItem.length) {

              const visibleImages = jQuery('.tukave-main-content img');
              const visibleImagesCount = visibleImages.length;

              if (visibleImagesCount == 0) {
                // No actions necessary, scroll target into view
                setTimeout(() => {
                  scrollToTarget(hashItem[0], "smooth");
                }, 100);

                return;
              }

              let visibleImagesLoaded = 0;
              let visibleImagesLogicComplete = false;
              jQuery(visibleImages).each((index, singleImage) => {

                // For loaded images
                if (singleImage.complete) {
                  visibleImagesLoaded += 1;
                  if (visibleImagesCount === visibleImagesLoaded) {
                    // All images have been loaded, run scroll logic  
                    setTimeout(() => {
                      scrollToTarget(hashItem[0], "smooth");
                      visibleImagesLogicComplete = true;
                    }, 100);
                  }

                  return;
                }

                // For unloaded images, detect image loading 
                jQuery(singleImage).on('load', (img) => {

                  if (visibleImagesLogicComplete) return; // Prevent late loading images causing another scroll

                  visibleImagesLoaded += 1;
                  if (visibleImagesCount === visibleImagesLoaded) {
                    // All images have been loaded, run scroll logic  
                    setTimeout(() => {
                      scrollToTarget(hashItem[0], "smooth");
                      visibleImagesLogicComplete = true;
                    }, 100);
                  }
                });
              });

              setTimeout(() => {
                // Fallback for images failing to load
                if (visibleImagesCount !== visibleImagesLoaded) {
                  scrollToTarget(hashItem[0], "instant");
                  visibleImagesLogicComplete = true;
                }
              }, 5000);
            }

            return;
          }

          // Prevent page-level scroll when app is loaded first time
          if (this.initialLoad) {
            return;
          }

          this.setScrollingReserved(true);

          setTimeout(() => {
            let scrollTarget = jQuery('.tukave-main-content');
            scrollTarget[0].scrollIntoView({behavior: "smooth"});

            // Focus main content area
            document.getElementById('tuka-content-container').focus({
              preventScroll: true
            });

          }, 100);

          setTimeout(() => {
            this.setScrollingReserved(false);
          }, 2000)

        });
      },
      deep: true
    },
  },
};
</script>